"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Button = _interopRequireDefault(require("../Button"));

var _constant = require("./constant");

var _SlideDown = _interopRequireDefault(require("./SlideDown.proptypes"));

var _constant2 = require("../JourneyPriceCTA/constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "SlideDown__Wrapper",
  componentId: "sc-c4on0-0"
})(["display:flex;flex-direction:column;"]);

var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "SlideDown__ButtonWrapper",
  componentId: "sc-c4on0-1"
})(["display:flex;align-items:center;align-self:center;justify-content:center;", ""], function (_ref) {
  var hidden = _ref.hidden;
  return !hidden && (0, _styledComponents.css)(["display:none;"]);
});

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "SlideDown__ContentWrapper",
  componentId: "sc-c4on0-2"
})(["display:flex;flex-direction:column;"]);

var SlideDown = function SlideDown(_ref2) {
  var theme = _ref2.theme,
      accessible = _ref2.accessible,
      customProperties = _ref2.customProperties,
      children = _ref2.children,
      handleClick = _ref2.handleClick,
      translation = _ref2.translation;

  var _React$useState = _react.default.useState(true),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      show = _React$useState2[0],
      setShow = _React$useState2[1];

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  (0, _react.useEffect)(function () {
    var scrollDown = function scrollDown() {
      setTimeout(function () {
        var slideDownContent = document.getElementById(_constant.SLIDEDOWN_CONTENT_ID);
        if (slideDownContent) slideDownContent.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 150);
    };

    scrollDown();
  }, [show]);

  var handleCta = function handleCta() {
    if (handleClick) handleClick(function () {
      setShow(false);
    });else {
      setShow(false);
    }
  };

  var isMoveTheme = theme === _constant2.THEMES.MOVE;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties), /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    hidden: show
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    accessible: accessible,
    backgroundColor: _constant2.movePrimaryButton[isMoveTheme].backgroundColor,
    boxShadow: false,
    buttonType: "button",
    cardIndex: 0,
    color: _constant2.movePrimaryButton[isMoveTheme].color,
    border: _constant2.movePrimaryButton[isMoveTheme].border,
    disabled: false,
    hoverBackgroundColor: _constant2.movePrimaryButton[isMoveTheme].backgroundColor,
    hoverColor: _constant2.movePrimaryButton[isMoveTheme].color,
    size: "normal",
    width: "100%",
    target: "self",
    theme: theme,
    type: "normal",
    handleClick: handleCta
  }, language.slideDownCta)), !show && /*#__PURE__*/_react.default.createElement(ContentWrapper, {
    id: _constant.SLIDEDOWN_CONTENT_ID
  }, children)));
};

SlideDown.propTypes = _SlideDown.default.PropTypes;
SlideDown.defaultProps = _SlideDown.default.DefaultProps;
var _default = SlideDown;
exports.default = _default;